import React,{Component} from 'react';
import './DynamicAssets.scss'
import DynamicAsset from './DynamicAsset/DynamicAsset';
import data from './assetData';


class DynamicAssets extends Component{
render(){
    const assetData =data;

    const dynamicAssets= assetData.map((assetData, i) => {
        if(assetData.roles.includes(this.props.role)){
        return(
            <DynamicAsset 
            title={assetData.title} 
            image={assetData.image}
            description={assetData.description} 
            ctaText={assetData.cta_text}
            ctaURL={assetData.url}
            tabby={i+1}
            />
        )
        }
    });
    return(
        <div>
    {dynamicAssets}
        </div>
    
    )
}

}




export default DynamicAssets